import type { CampingSpot } from '../types';

/**
 * Slå sammen `spots`- og `cached_spots`-versjonen av samme plass ved oppslag på id.
 *
 * `cached_spots` holder den autoritative geometrien (location/navn) for OSM- og
 * kommersielle plasser. `spots` kan for slike plasser inneholde bare en DELVIS stub
 * med denormaliserte felter — f.eks. ratingAverage/ratingCount skrevet av
 * `onReviewWrite` — UTEN `location`. Leser vi bare `spots` først og returnerer den
 * stubben, mangler resultatet koordinater, og kart-fly + valg avbryter stille
 * (`handleSelectSpot` returnerer på `!s.location`). For manuelle/bekreftede plasser
 * er `spots` derimot den fulle kilden.
 *
 * Løsning: cached som base (gir alltid koordinater når den finnes), spots-feltene
 * overstyrer (ferske ratings osv.). Nøkler som mangler i stubben faller da tilbake
 * til cached-verdien. Returnerer `null` når ingen av kildene finnes.
 */
export const mergeSpotDocs = (
  mainData: Partial<CampingSpot> | null | undefined,
  cachedData: Partial<CampingSpot> | null | undefined,
  spotId: string,
): CampingSpot | null => {
  if (!mainData && !cachedData) return null;
  const merged = { ...(cachedData || {}), ...(mainData || {}) } as CampingSpot;
  return { ...merged, id: merged.id || spotId };
};
